import React from 'react';

import {NoResultPage} from 'src/modules/entitlements';

import {pluralize} from '@pb/kit-formatters';

import {
    NO_ASSIGNED_ENTITLEMENT_DESCRIPTION,
    NO_ASSIGNED_ENTITLEMENT_TITLE,
} from '../constants';

import type {ResourceView} from 'src/modules/entitlements/typedef';

type Props = {
    result: {data: ResourceView[], totalCount: number} | null,
    filteredResources: string[] | undefined,
};

export const NoResultMessage = ({filteredResources, result}: Props) => {
    if (filteredResources && !filteredResources.length) {
        return (
            <NoResultPage
                title="No resources found for the selected criteria."
                description=""
            />
        );
    }

    if (result && !result.totalCount && filteredResources?.length) {
        return (
            <NoResultPage
                title={pluralize(
                    `The searched resource[s] is not assigned to any grant`,
                    filteredResources.length,
                )}
                description={pluralize(
                    `Please assign the resource[s] to some grant to view [it, them] on this page.`,
                    filteredResources.length,
                )}
            />
        );
    }

    if (result && !result.data.length) {
        return (
            <NoResultPage
                title={NO_ASSIGNED_ENTITLEMENT_TITLE}
                description={NO_ASSIGNED_ENTITLEMENT_DESCRIPTION}
            />
        );
    }

    return <div/>;
};
